import { spWindow } from "./spWindow";
import { NavigationResponse } from "./model/NavNode";
declare var window: spWindow;

const baseUrl = "/_vti_bin/adesso.Hsd.KoFi.Portal/RestService.svc/";

const getNavigation = (): Promise<NavigationResponse> => {
    const url = `${window._spPageContextInfo.webAbsoluteUrl + baseUrl}GetNav?url=${decodeURIComponent(window.location.href)}`
    return new Promise<NavigationResponse>((resolve, reject) => {
        fetch(url).then(
            resp => {
                if (resp.status == 200 && !resp.redirected) {
                    resp.json().then((navNodes:NavigationResponse) => {
                        resolve(navNodes);
                    }).catch((er) => {
                        reject(er);
                    });
                } else {
                    reject(resp.statusText);
                }
            }).catch((er) => {
                reject(er);
            });
    });
}

const apiService = {
    getNavigation: getNavigation
}
export default apiService;